module.exports = __webpack_public_path__ + "static/media/carta_65.e8b6cbf2.jpg";